// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont-internalError{
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.body-internalErro{
    position: relative;
    width: 50%;
    height: 70%;

}
.cont-img-internalErro{
    position: relative;
    width: 100%;
    height: 70%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.cont-txt-internalErro{
    position: relative;
    width: 100%;
    height: 30%;
   
}
.img-InternalError{
    position: relative;
    width: 60%;
    /* height: 50%; */
}

.cont-txt-top-internalErro{
    color: red;
    font-size:xx-large;
    font-family: "Roboto" !important;
    font-weight: bold;
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}
.cont-txt-bot-internalErro{
    color: rgb(121, 121, 121);
    font-size:large;
    font-family: "Roboto" !important;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/generales/styles/InternalError.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;;AAEf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;;AAEf;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB","sourcesContent":[".cont-internalError{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.body-internalErro{\r\n    position: relative;\r\n    width: 50%;\r\n    height: 70%;\r\n\r\n}\r\n.cont-img-internalErro{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 70%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.cont-txt-internalErro{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 30%;\r\n   \r\n}\r\n.img-InternalError{\r\n    position: relative;\r\n    width: 60%;\r\n    /* height: 50%; */\r\n}\r\n\r\n.cont-txt-top-internalErro{\r\n    color: red;\r\n    font-size:xx-large;\r\n    font-family: \"Roboto\" !important;\r\n    font-weight: bold;\r\n    width: 100%;\r\n    height: 50%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n}\r\n.cont-txt-bot-internalErro{\r\n    color: rgb(121, 121, 121);\r\n    font-size:large;\r\n    font-family: \"Roboto\" !important;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
